import Start_Main_Start_Button from "./Start_Main_Start_Button";
import logo_google from "../../images/google.png";
import logo_apple from "../../images/apple.png";
import Start_Main_Start_Button_Image from "./Start_Main_Start_Button_Image";
import Start_Main_Or from "./Start_Main_Or";
import Start_Main_SignIn_Form from "./Start_Main_SignIn_Form";
import React from "react";

class Start_Main_SignIn_MainSection extends React.Component {
    render() {
        return(
            <div className="start_main_signIn_MainSection">
                <Start_Main_Start_Button text="Sign in with Google" classButton="start_main_signIn_btnGoogle" image={<Start_Main_Start_Button_Image src={logo_google} alt="logo_google" />} classText="start_main_signIn_button_text_google" />
                <Start_Main_Start_Button text="Sign in with Apple" classButton="start_main_signIn_btnApple" image={<Start_Main_Start_Button_Image src={logo_apple} alt="logo_apple" />} classText="start_main_signIn_button_text_apple" />
                <Start_Main_Or />
                <Start_Main_SignIn_Form />
                <Start_Main_Start_Button text="Forgot password?" classButton="start_main_signIn_forgotPass" classText="start_main_signIn_button_text_forgot" />
            </div>
        )
    }
}

export default Start_Main_SignIn_MainSection;